import React, { PureComponent, PropTypes } from 'react'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import CircularProgressbar from 'react-circular-progressbar'

import * as selectors from './miniPlayerSelectors'

class ProgressCircle extends PureComponent {

	constructor(props) {
		super(props)
		this.smoothUpdate = null
		this.state = {
			played: 0,
			playing: false
		}
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.seek === 0) this.setState({ played: 0 })

		// On attend que les infos de la musique soient chargées pour lancer la progress bar
		if (nextProps.loaded) {
			if ((this.props.playing !== nextProps.playing || this.props.seek !== nextProps.seek)) {
				this.setState({
					playing: nextProps.playing
				})
				if (this.smoothUpdate) {
					clearInterval(this.smoothUpdate)
					this.smoothUpdate = null
				}
				// on réajuste la position avec le seek quand celui-ci change
				if (this.props.seek !== nextProps.seek) {
					this.setState({
						played: nextProps.seek
					})
				}

				// lorsque l'on est en train de lire,
				// on ajoute un setInterval pour faire une lecture plus fluide (played += step)
				if (nextProps.playing) {
					// on prend 25 frames par secondes
					if (this.props.duration) {
						const step = 1 / 25
						this.smoothUpdate = setInterval(() => {
							// on ne met à jour la position que si on est en lecture
							if (this.state.playing && !this.props.buffering) {
								this.setState({
									played: this.state.played + step
								})
							}
						}, 40)
					}
				} else if (this.smoothUpdate) {
					// Sinon, on supprime l'interval de mise à jour de la progress bar
					clearInterval(this.smoothUpdate)
					this.smoothUpdate = null
				}
			}
		}
	}

	componentWillUnmount() {
		if (this.smoothUpdate) {
			clearInterval(this.smoothUpdate)
		}
		this.smoothUpdate = null
	}


	render() {
		return (
			<CircularProgressbar percentage={this.state.played * 100 / this.props.duration} textForPercentage={() => {}} />
		)
	}
}

ProgressCircle.propTypes = {
	seek: PropTypes.number,
	duration: PropTypes.number,
	buffering: PropTypes.bool,
	playing: PropTypes.bool,
	loaded: PropTypes.bool
}

ProgressCircle.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state) => ({
	seek: selectors.getSeek(state),
	duration: selectors.getDuration(state),
	buffering: selectors.isBuffering(state),
	playing: selectors.isPlaying(state),
	loaded: selectors.isLoaded(state)
})

const actions = {}

export default connect(mapStateToProps, actions)(ProgressCircle)



// WEBPACK FOOTER //
// ./src/components/miniPlayer/ProgressCircle.jsx